import React from 'react'
import $ from 'jquery'
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorker";
import App from "../src/App";
// import ZeroWorkEditor from "./plugins/Editor";
import Form2FileUpload from "./Form2FileUpload";

class DownloadReportModal extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				<Modal onApprove={() => false}
				       closable={false}
				       onDeny={() => {
					       this.ajax.abort();
				       }}
				       onHide={() => {
					       this.ajax.abort();
				       }}
				       onShow={(ref) => {
					       this.$modal = ref;
					       this.ajax = window.Global.ajax({
						       method: 'GET',
						       url: this.props.url,
						       data: this.props.data,
						       done: (response) => {
							       if (!response.success) {
								       return false;
							       }
							       window.$('body').append('<iframe src="' + response['download_url'] + '" style="width: 0;height: 0;"></iframe>');
							       window.$(this.$modal).modal('hide');
						       },
						       fail: () => {

						       }
					       });
				       }}
				>
					<div className="header">กำลังเตรียมรายงานสำหรับคุณ</div>
					<div className="content">
						<form ref={e => this.$form = e} className="ui form">
							<div className="ui indicating progress active" data-percent="100">
								<div className="bar" style={{width: '100%'}}/>
								<div className="label">กำลังโหลด ไม่ต้องปิดหน้าต่าง...</div>
							</div>
							<div className="ui error message"/>
						</form>
					</div>
				</Modal>
			</div>
		);
	}
}

class Modal extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div ref={(ref) => {
				window.$(ref).modal({
					closable: this.props.closable === undefined ? true : this.props.closable,
					autofocus: this.props.autofocus === undefined ? false : this.props.autofocus,
					observeChanges: this.props.observeChanges === undefined ? true : this.props.observeChanges,
					onShow: () => {
						if (this.props.onShowToSetupForm) {
							return this.props.onShowToSetupForm(window.$(ref));
						}
						if (this.props.onShow) {
							return this.props.onShow(ref);
						}
					},
					onApprove: ($element) => {
						if (this.props.onShowToSetupForm) {
							window.$(ref).find('form').trigger('submit');
							return false;
						}
						if (this.props.onApprove) {
							let $button = window.$(ref).find('.approve.button');
							if ($button.hasClass('loading')) return false;
							$button.addClass('loading');
							return this.props.onApprove(ref, $element);
						}
					},
					onDeny: ($element) => {
						if (this.props.onDeny) {
							return this.props.onDeny(ref, $element);
						}
					},
					onHide: ($element) => {
						setTimeout(function () {
							window.$(ref).remove();
						}, 1500);
						if (this.props.onHide) {
							return this.props.onHide(ref, $element);
						}
					}
				}).modal('show');
			}}
			     className={!this.props.className ? "ui tiny modal" : this.props.className}>
				<i className="close icon"/>
				{this.props.children}
			</div>
		);
	}
}

class AddressForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			title: this.props.title,
			type: this.props.type,
			payment: this.props.payment,
		}
	}

	setValue() {
		let type = this.state.type;
		let relationship = '';
		let branch_name = '';
		let branch_code = '';
		let bill_line_1 = '';
		let bill_line_2 = '';
		let options = {};
		let $parent = {};
		let relationshipBranceType = {};
		let $editBuyerInformationButton = {};
		let $editSellerInformationButton = {};

		this.$parent.find('input[name="' + type + '_company_name"]').val(relationship['name']);
		this.$parent.find('input[name="' + type + '_branch_name"]').val(branch_name);
		this.$parent.find('input[name="' + type + '_branch_code"]').val(branch_code);
		this.$parent.find('input[name="' + type + '_bill_line_1"]').val(bill_line_1);
		this.$parent.find('input[name="' + type + '_bill_line_2"]').val(bill_line_2);
		this.$parent.find('input[name="' + type + '_tax_number"]').val(relationship['tax_number']);
		window.GlobalFunc.setManageAddressButton2({
			$node: options.$node
		});

		if (options.onSuccess) {
			options.onSuccess();
		}
		window.GlobalFunc.selectedRelationshipToSetupAddress($parent, {
			relationship: relationship,
			type: relationshipBranceType,
			$node: this.state.payment.type === 'receive_advance_payment' ? $editBuyerInformationButton : $editSellerInformationButton
		});
	}

	renderBuyer() {
		return (
			<div className="column field">
				{
					this.state.title ?
						<label style={{display: 'inline-block', marginRight: 5}}>{this.state.title}</label>
						:
						null
				}
				{this.state.payment.buyer_company_name}
				{
					this.state.payment.buyer_branch_name
						? ' สาขา ' + this.state.payment.buyer_branch_name
						: null
				}
				{
					this.state.payment.buyer_bill_line_1
						?
						<div>{this.state.payment.buyer_bill_line_1}</div>
						: null
				}
				{
					this.state.payment.buyer_bill_line_2
						?
						<div>{this.state.payment.buyer_bill_line_2}</div>
						: null
				}
				{
					this.state.payment.buyer_tax_number
						?
						<div>เลขประจำตัวผู้เสียภาษี {this.state.payment.buyer_tax_number}</div>
						: null
				}
			</div>
		);
	}

	renderSeller() {
		return (
			<div className="column field">
				{
					this.state.title ?
						<label style={{display: 'inline-block', marginRight: 5}}>{this.state.title} </label>
						:
						null
				}
				{this.state.payment.seller_company_name}
				{
					this.state.payment.seller_branch_name
						? ' สาขา ' + this.state.payment.seller_branch_name
						: null
				}
				{
					this.state.payment.seller_bill_line_1
						?
						<div>{this.state.payment.seller_bill_line_1}</div>
						: null
				}
				{
					this.state.payment.seller_bill_line_2
						?
						<div>{this.state.payment.seller_bill_line_2}</div>
						: null
				}
				{
					this.state.payment.seller_tax_number
						?
						<div>เลขประจำตัวผู้เสียภาษี {this.state.payment.seller_tax_number}</div>
						: null
				}
			</div>
		);
	}

	render() {
		if (!this.state.mode) {
			if (this.state.type === 'buyer') {
				return this.renderBuyer()
			}
			if (this.state.type === 'seller') {
				return this.renderSeller()
			}
		}

		return (
			<div className="column field"
			     ref={(ref) => {
				     this.$parent = window.$(ref);
			     }}
			     id="editSellerInformationButton">
				<div className="flex row">
					<p className="SaleOrder_address"
					   data-title="ผู้รับเงิน">-</p>
				</div>
				<input type="hidden" name="seller_company_name" data-company_name/>
				<input type="hidden" name="seller_branch_name" data-branch_name/>
				<input type="hidden" name="seller_branch_code" data-branch_code/>
				<input type="hidden" name="seller_bill_line_1" data-bill_line_1/>
				<input type="hidden" name="seller_bill_line_2" data-bill_line_2/>
				<input type="hidden" name="seller_tax_number" data-tax_number/>
			</div>
		);
	}
}

// ReactDOM.render(
// 	<React.StrictMode>
// 		<App/>
// 	</React.StrictMode>,
// 	document.getElementById('root')
// );
//
// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

// if (!process.env.NODE_ENV
// 	|| process.env.NODE_ENV === 'development'
// ) {
// 	// dev code
// 	ReactDOM.render(<App/>, document.getElementById('root'));
// } else {
// 	// production code
// }

// ReactDOM.render(<App/>, document.getElementById('root'));

export {DownloadReportModal, Modal, Form2FileUpload, AddressForm};
